/* tslint:disable */

/**
 */
export class LayoutGeneration {
    SHELVES_TYPE?: number;
    ID_LAYOUT_GENERATION?: number;
    LENGTH_INTERVAL?: number;
    NB_SHELVES_PERSO?: number;
    PROD_POSITION?: number;
    SHELVES_LENGTH?: number;
    ID_STUDY_EQUIPMENTS?: number;
    SHELVES_WIDTH?: number;
    WIDTH_INTERVAL?: number;
    SHELVES_EURO_LENGTH?: number;
    SHELVES_EURO_WIDTH?: number;
    SHELVES_GASTRO_LENGTH?: number;
    SHELVES_GASTRO_WIDTH?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/layout-generation.ts